import * as React from 'react';
import { getAppStore } from '../../app/AppStore';
import { Messages } from '../../codegen/Localize';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';
import { editFlow } from '../actions/EditFlowReduxAction';
import { DraftBannerAction, DraftBanner } from '../../drafts/components/DraftBanner';
import { imgPath } from '../../common/utilities/ImgUrl';
import { deleteFlowDraft } from '../actions/DeleteFlowDraftReduxAction';

export type FlowDraftBannerProps = {
  readonly flow: ISpaceItemDetailInfo<'flow'>;
};

export function FlowDraftBanner(props: FlowDraftBannerProps): JSX.Element {
  if (!props.flow || !props.flow.flowDraft) {
    return null;
  }

  const handleEditFlow = () => {
    if (props?.flow) {
      getAppStore().dispatch(editFlow(props.flow));
    }
  };

  const handleDeleteDraft = () => {
    if (props?.flow) {
      getAppStore().dispatch(deleteFlowDraft([props.flow]));
    }
  };

  const continueEditBannerAction: DraftBannerAction = {
    label: Messages.continueEditing(),
    handleAction: handleEditFlow,
    iconPath: imgPath('pencil_14px_small.svg'),
    testId: 'continue-editing'
  };

  const deleteDraftBannerAction: DraftBannerAction = {
    label: Messages.deleteDraft(),
    handleAction: handleDeleteDraft,
    iconPath: imgPath('trash_14px_small.svg'),
    testId: 'delete-draft'
  };

  return (
    <DraftBanner
      lastEditDate={props.flow.flowDraft.lastUpdatedAt}
      draftBannerActions={[continueEditBannerAction, deleteDraftBannerAction]}
      contentTypeName={Messages.lastEditedFlow()}
    />
  );
}